document.addEventListener('DOMContentLoaded', function () {

  const currentYear = new Date().getFullYear();
  const nextYear    = currentYear + 1;

  // ─── Holiday / blocked dates ────────────────────────────────────────────
  const diasFestivos = [
    "01/01/" + currentYear, // Nacional
    "02/01/" + currentYear, // No hay entrega
    "06/01/" + currentYear, // Nacional
    "02/04/" + currentYear, // Nacional
    "03/04/" + currentYear, // Nacional
    "07/04/" + currentYear, // No hay entrega
    "01/05/" + currentYear, // Nacional
    "05/06/" + currentYear, // Castilla La Mancha
    "13/10/" + currentYear, // Nacional
    "08/12/" + currentYear, // Nacional
    "24/12/" + currentYear, // No hay entrega
    "25/12/" + currentYear, // Nacional
    "31/12/" + currentYear, // Nacional
    "01/01/" + nextYear,    // Nacional
    "02/01/" + nextYear,    // No hay entrega
    "06/01/" + nextYear,    // Nacional
    "07/01/" + currentYear, // desborde
    "08/01/" + currentYear, // desborde
    "09/01/" + currentYear, // desborde
    "13/01/" + currentYear, // desborde
    "03/03/" + currentYear, // desborde
    "10/03/" + currentYear, // desborde
    "24/03/" + currentYear, // desborde
    "08/04/" + currentYear, // desborde
    "14/04/" + currentYear, // desborde
    "09/06/" + currentYear, // desborde
    "07/07/" + currentYear, // desborde
    "14/07/" + currentYear, // desborde
    "28/07/" + currentYear, // desborde
    "11/08/" + currentYear, // desborde
    "18/08/" + currentYear, // desborde
    "25/08/" + currentYear, // desborde
    "01/09/" + currentYear, // desborde
    "08/09/" + currentYear, // desborde
    "15/09/" + currentYear,
    "03/11/" + currentYear, // Castilla La Mancha
    "04/11/" + currentYear
  ];

  // Define the variable to hold enabled days
  const enableDays = []; // You can populate this array if needed

  // ─── Helper: format a Date to "dd/mm/yyyy" ──────────────────────────────
  function formatDate(date) {
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = date.getFullYear();
    return `${d}/${m}/${y}`;
  }

  // ─── Disable logic ───────────────────────────────────────────────────────
  function isDisabledDay(date) {
    const dia = date.getDay(); // 0=Sun, 1=Mon, 6=Sat
    const formatted = formatDate(date);
    const isWeekend = dia === 0 || dia === 1 || dia === 6;

    if (isWeekend) {
      return enableDays.includes(formatted); // true = enabled
    }

    return !diasFestivos.includes(formatted); // true = enabled
  }

  // ─── Min/Max date ──────────────────────────────────────────────────────
  const currentdate = new Date();
  currentdate.setDate(currentdate.getDate() + 2);

  const maxDate = new Date();
  maxDate.setMonth(maxDate.getMonth() + 2);

  // ─── Flatpickr initialization ───────────────────────────────────────────
  const datepickerEl = document.getElementById('datepicker');

  if (datepickerEl) {
    const picker = flatpickr(datepickerEl, {
      locale: 'es',               // Spanish locale
      minDate: currentdate,
      maxDate: maxDate,
      dateFormat: 'l, d F Y',    // e.g. "Lunes, 21 Abril 2025"
      clickOpens: false,         // Ensure this is set to false
      disable: [
        function (date) {
          return !isDisabledDay(date); // Disable specific dates
        }
      ],
      onChange: function(selectedDates, dateStr, instance) {
        // Use 'instance' to control the picker
        if (selectedDates.length > 0) {
          instance.close(); // Close the datepicker
        }
      },
      // Prevent typing in the field
      allowInput: false,
    });

    // Open the datepicker when the input is clicked
    datepickerEl.addEventListener('click', function() {
      // Use the flatpickr instance directly to open the picker
      document.querySelector('.flatpickr-calendar').classList.remove('hide');
      console.log("Picker Open");
    });

    // Open the datepicker when the input is clicked
    datepickerEl.addEventListener('change', function() {
      // Use the flatpickr instance directly to open the picker
      console.log("Picker close");
      document.querySelector('.flatpickr-calendar').classList.add('hide');
      picker.close(); 
    });    

    // ─── Block keyboard input ──────────────────────────────────────────
    datepickerEl.addEventListener('keydown', function (e) {
      e.preventDefault(); // Prevent typing in the field
    });
  }

  // ─── Form submission validation ─────────────────────────────────────────
  const cartForm = document.getElementById('cartform2');

  if (cartForm) {
    cartForm.addEventListener('submit', function (event) {
      let error = 0;

      // 1. Terms and conditions checkbox
      const agreeCheckbox = document.getElementById('agree');
      if (!agreeCheckbox || !agreeCheckbox.checked) {
        error++;
      }

      // 2. Fix bug with Google Translate corrupting date value
      const errorDate = 'undefined, NaN undefined NaN';
      const valueDate = datepickerEl ? datepickerEl.value : '';
      if (valueDate === errorDate || valueDate === '') {
        error++;
      }

      // 3. Validate all required (.requerido) inputs
      const requeridoFields = document.querySelectorAll('.requerido');
      requeridoFields.forEach(function (elem) {
        if (elem.value === '') {
          elem.style.border = '1px solid #D03936';
          error++;
        } else {
          elem.style.border = '1px solid #A9A9A9';
        }
      });

      // 4. Show error alert if any validation failed
      if (error > 0) {
        event.preventDefault();

        const avisoEl = document.getElementById('aviso');
        if (avisoEl) {
          avisoEl.innerHTML =
            '<div class="alert alert-danger alert-dismissible fade in" role="alert">' +
            '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
            '<span aria-hidden="true">&times;</span></button>' +
            '<strong>Ups!</strong> Debes elegir una fecha de entrega y aceptar los terminos y condiciones' +
            '</div>';
        }

        error = 0;
      }
    });
  }

});
